import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "../../services/CRUDServices";

export const filterSurveyResults: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "survey-results",
  async (body: any) => {
    let { data } = await filterTableDataAPI(
      "/customer-api/surveyResponse/v1/s1/filter",
      body.pageNumber,
      {
        ...body,
        pageNumber: undefined,
        pageSize: undefined,
      },
      true,
      body.pageSize,
      false
    );

    console.log("data is",data)
    return { data:data.response };
  }
);

const initialState: any = {
  surveyResultsData: [],
  fetchpost: false,
  errorMessage: null,
  filter: {},
};

const SurveyResultsSlice = createSlice({
  initialState: initialState,
  name: "survey-results",
  reducers: {

    // clearGroupPayment: (state) => {
    //   state.deliveryList = [];
    // },
    setFilterSurveyResult: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterSurveyResults.fulfilled as any]: (state, action) => {
      state.surveyResultsData = action.payload.data;
      state.fetchpost = false;
    },
    [filterSurveyResults.pending as any]: (state) => {
      state.fetchpost = true;
    },
    [filterSurveyResults.rejected as any]: (state) => {
      state.fetchpost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const {  setFilterSurveyResult } = SurveyResultsSlice.actions;
export default SurveyResultsSlice.reducer;
